package com.kinoshazam.view

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.DrawerState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.kinoshazam.screens.rootFlow.AppVersionWatermark
import com.kinoshazam.uiKit.components.localizedResourceKey
import com.kinoshazam.uiKit.components.menuItem.MenuItem
import com.kinoshazam.uiKit.components.menuItem.MenuItemState
import com.kinoshazam.uiKit.components.cells.cellIcon.CellIconItem
import com.kinoshazam.uiKit.components.cells.cellIcon.CellIconItemState
import com.kinoshazam.uiKit.theme.UiKitTheme
import kinoshazam.resources.generated.resources.Res
import kinoshazam.resources.generated.resources.about
import kinoshazam.resources.generated.resources.fantastic
import kinoshazam.resources.generated.resources.profile_title
import kinoshazam.resources.generated.resources.update_available
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import presentation.screens.main.MainMVIAction
import presentation.screens.main.MainState
import presentation.screens.main.MainState.DrawerStateValue

@Composable
fun DrawerContent(
    drawerState: DrawerState,
    state: MainState,
    onAction: (MainMVIAction) -> Unit,
) {
    Column(
        modifier = Modifier
            .fillMaxSize()
            .navigationBarsPadding(),
    ) {
        Column(
            modifier = Modifier
                .weight(1f)
                .verticalScroll(rememberScrollState()),
        ) {
            Column(modifier = Modifier.padding(horizontal = 16.dp)) {

                if (true) { // GlobalConfig.features.registration
                    Spacer(Modifier.padding(top = 32.dp))

                    CellIconItem(
                        state = CellIconItemState(
                            gap = 26.dp,
                            title = state.user?.userName ?: state.user?.email
                            ?: stringResource(Res.string.profile_title),
                            iconRes = state.user?.avatar,
                            iconPlaceholder = painterResource(Res.drawable.fantastic),
                        ),
                        onClick = {
                            onAction(MainMVIAction.ProfileClicked)
                        }
                    )
                }

                Spacer(Modifier.padding(top = 40.dp))

                state.menuItems.forEach {
                    MenuItem(
                        state = MenuItemState(
                            gap = 26.dp,
                            title = localizedResourceKey(it.title),
                            iconRes = it.icon,
                            isSelected = it == state.selectedMenu,
                            onAction = {
                                onAction(MainMVIAction.OnMenuItemClicked(it))
                            }
                        )
                    )
                }
            }

            Spacer(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(vertical = 10.dp)
                    .height(1.dp)
                    .background(color = UiKitTheme.colors.color_3)
            )

            MenuItem(
                modifier = Modifier.padding(horizontal = 16.dp),
                state = MenuItemState(
                    gap = 26.dp,
                    title = stringResource(Res.string.about),
                    iconRes = "info.xml",
                    onAction = {
                        onAction(MainMVIAction.AppInfo)
                    }
                )
            )

            Spacer(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(vertical = 10.dp)
                    .height(1.dp)
                    .background(color = UiKitTheme.colors.color_3)
            )

            if (state.updateAvailable) {
                Spacer(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(vertical = 10.dp)
                        .height(1.dp)
                        .background(color = UiKitTheme.colors.color_3)
                )

                MenuItem(
                    modifier = Modifier.padding(horizontal = 16.dp),
                    state = MenuItemState(
                        gap = 26.dp,
                        title = stringResource(Res.string.update_available),
                        iconRes = "update.xml",
                        tintColor = UiKitTheme.colors.color_1,
                        animateIcon = true,
                        onAction = {
                            onAction(MainMVIAction.ClickBackWithDrawer)
                            onAction(MainMVIAction.UpdateClicked) // TODO: navigate to confirm dialog
                        }
                    )
                )
            }
        }

        AppVersionWatermark(
            onClick = { onAction(MainMVIAction.AppInfo) },
        )
    }
}

@Composable
fun HandleDrawer(
    drawerState: DrawerState,
    state: MainState,
    onAction: (MainMVIAction) -> Unit,
) {
    LaunchedEffect(state.drawerState) {
        when (state.drawerState) {
            DrawerStateValue.OPEN -> {
                try {
                    drawerState.open()
                } finally {
                    onAction.invoke(MainMVIAction.OnDrawerOpened)
                }
            }

            DrawerStateValue.OPENED -> Unit
            DrawerStateValue.CLOSED -> drawerState.close()
        }
    }
    if (drawerState.isOpen) {

//        BackDispatcher().register(object : BackCallback() {
//            override fun onBack() {
//                onAction(MainMVIAction.ClickBackWithDrawer)
//            }
//        })
    }
}